import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge only knows Tailwind's built-in font sizes. Without this it reads the custom
// `--text-*` sizes in index.css as colours, so `cn('text-ink-inverse', 'text-caption')` dropped
// the colour and `cn('text-sm', 'text-caption')` kept both sizes.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['micro', 'caption', 'nav'],
    },
  },
});

export const cn = (...classNames: ClassValue[]) => twMerge(clsx(classNames));
